import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "../data/content";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="floating-whatsapp-btn"
    href={`https://wa.me/${WHATSAPP.phone}?text=${encodeURIComponent(WHATSAPP.message)}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contattaci su WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="animate-soft-pulse fixed bottom-6 right-6 z-50 flex w-14 h-14 items-center justify-center rounded-full bg-[#25D366] text-[#181410] shadow-[0_8px_30px_rgba(37,211,102,0.35)] hover:scale-110 transition-transform duration-300"
  >
    <MessageCircle className="w-6 h-6" />
  </motion.a>
);
